import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  RequiredField: {
    color: theme.palette.green,
    height: '30px',
    margin: '10px',
    width: '100%',
  },
}));

export { useStyles };
